let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bOQCu")).then(() => parcelRequire('4dVBj'));